import Cookie from 'js-cookie';
import { LocationUtilities, SiteUtilities, ResponsiveUtilities } from '../utils';
import GA4Utilities from '../utils/ga4-utilities';
import GenericFormHandlers from './miscellaneous-form-handlers';
import { getAwinConversionPayload } from '../affiliate-marketing-handlers/index';

let emailOld = ''; // fdesk spam check
let uidOld = '';

const logSignupErrOnFail = function (failureLogData, form) {
  return function (jqXHR) {
    if (!jqXHR.status) return;
    const apiName = failureLogData.source.indexOf('Email') > -1 ? 'Email only Signup' : 'Signup';
    failureLogData['message'] = `Freshdesk ${apiName} API call failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText}`;
    SiteUtilities.signupErrorLog(failureLogData, form);
  };
};

var fdeskForm = function (classname, form) {
  const geoLocation = LocationUtilities.getGeoLocation();
  const $form = $(form);
  // Presetted and Fetched constants
  let signUpApiUrl = 'https://freshsignup.freshdesk.com/accounts/new_signup_free';
  const spamCheckUrl = $form.data('spam-check-url') || 'https://alfred.freshworks.com/v1/dark-knight';

  const dataCenter = $('[name="data-center-dropdown"]').val();
  switch (dataCenter) {
    case 'EU':
      signUpApiUrl = 'https://eucentral1login.freshdesk.com/accounts/new_signup_free';
      break;

    case 'AU':
      signUpApiUrl = 'https://podapsoutheast2login.freshdesk.com/accounts/new_signup_free';
      break;

    case 'IN':
      signUpApiUrl = 'https://freshsignupindpod.freshdesk.com/accounts/new_signup_free';
      break;
  }

  const postData = [];
  let spamData = {};
  let currentLoc = '';
  const $signUpBtn = $form.find('.button');
  let uid = SiteUtilities.generateUID();

  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();
  const getSignupEndpointLang = (workflowLocale) => {
    // List of language keys accepted by the backend are listed below.
    /*
    ["ar", "ca", "cs", "da", "de", "en", "es-LA", "es", "et", "fi", "fr", "hu", "id", "it", "ja-JP", "ko", "nb-NO", "nl", "pl", "pt-BR", "pt-PT", "ru-RU", "sk", "sl", "sv-SE", "tr", "vi", "zh-CN", "uk", "he", "th", "ro", "zh-TW", "lv-LV"]
    */
    return {
      de: 'de',
      fr: 'fr',
      es: 'es',
      pt: 'pt-BR',
      'latam-es': 'es-LA',
      nl: 'nl',
      'sv-SE': 'sv-SE',
      en: 'en',
      ja: 'ja-JP',
      ru: 'ru-RU',
      ko: 'ko',
      it: 'it',
      'zh-CN': 'zh-CN',
      th: 'th',
      vi: 'vi',
      pl: 'pl',
      'zh-HK': 'zh-TW',
      fi: 'fi'
    }[workflowLocale];
  };
  const currentLang = $('body').attr('data-lang');
  const email = $form.find('.email-form').val() || '';
  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(email, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  // Setting Values
  $signUpBtn.addClass('button--loading').attr('disabled', 'disabled');
  $form.find('input[name="first_referrer-' + classname + '"]').val((Cookie.get('fw_fr') || currentLoc));
  $form.find('input[name="first_landing_url-' + classname + '"]').val((Cookie.get('fw_flu') || ''));

  // Binding maxmind_session
  const maxmindObj = geoLocation;
  sessionObj.location = geoLocation;

  currentLoc = (sessionObj && sessionObj.original_session) ? sessionObj.original_session.referrer : SiteUtilities.getCurrentLocation();
  if (currentReferrer && isExternalIframeSignup) {
    currentLoc = currentReferrer;
    sessionObj.current_session.url = `${SiteUtilities.getCurrentLocation()}?first_referrer=${currentReferrer}`;
  }
  const formSourceType = $form.attr('data-form-source');
  // changing the lead_source_choice based on form source Type which is available on form widget.
  if (formSourceType && sessionObj && sessionObj['current_session']) {
    sessionObj['current_session']['lead_source_choice'] = `${SiteUtilities.getParameterByName('utm_source')}` || formSourceType;
  }
  if (sessionObj && sessionObj.current_session) {
    let referrer = sessionObj.current_session.referrer;
    if (referrer === 'https://freshdesk.com/') {
      referrer = 'https://freshdesk.com';
    }
    sessionObj.current_session.referrer = referrer;
  }
  if (sessionObj && sessionObj.original_session) {
    let url = sessionObj.original_session.url;
    if (url === 'https://freshdesk.com/') {
      url = 'https://freshdesk.com';
    }
    sessionObj.original_session.url = url;
  }
  const sessionJSON = JSON.stringify(sessionObj);
  // Bind username and fs_cookie
  let fsCookie = '';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshdesk session exception.',
      'warning',
      'submitHandlers.fdeskForm',
      0,
      exception
    );
  }

  const emailNew = $form.find('.email-form').val();
  if (emailOld === emailNew) {
    uid = uidOld;
  }

  // Build postData
  postData.push(
    { name: 'user[first_name]', value: $form.find('.first-name-form').val() },
    { name: 'user[last_name]', value: $form.find('.last-name-form').val() },
    { name: 'user[email]', value: $form.find('.email-form').val() },
    { name: 'account[name]', value: $form.find('.company-form').val() },
    { name: 'user[phone]', value: $form.find('.phone-form').val() },
    { name: 'session_json', value: sessionJSON },
    { name: 'first_referrer', value: currentLoc },
    { name: 'last_referrer', value: document.referrer || '' },
    { name: 'first_landing_url', value: $form.find('input[name="first_landing_url-' + classname + '"]').val() },
    { name: 'noscript', value: $form.find('input[name="noscript"]').val() },
    { name: 'fd_cid', value: uid },
    { name: 'fs_cookie', value: fsCookie },
    { name: 'utc_offset', value: sessionObj.time.tz_offset || -5 },
    { name: 'source', value: `${SiteUtilities.getParameterByName('utm_source')}` } || formSourceType,
    { name: 'medium', value: `${SiteUtilities.getParameterByName('utm_medium')}` },
    { name: 'campaign', value: `${SiteUtilities.getParameterByName('utm_campaign')}` },
    { name: 'account[lang]', value: getSignupEndpointLang(currentLang) || 'en' }
  );

  const ipAddress = (maxmindObj && maxmindObj.ipAddress) ? maxmindObj.ipAddress : null;

  const failureLogData = {
    source: 'FW.Submit.fdeskForm',
    product: 'fdesk',
    ip_address: ipAddress,
    email: emailNew
  };

  // Posting signup to Freshdesk.
  const signupOptions = {
    type: 'POST',
    dataType: 'json',
    url: signUpApiUrl,
    data: postData,
    crossDomain: true,
    error: logSignupErrOnFail(failureLogData, form)
  };

  try {
    spamData = {
      emailAddress: $form.find('.email-form').val(),
      ipAddress: maxmindObj ? maxmindObj.ipAddress : '',
      accountName: $form.find('.company-form').val(),
      phone: $form.find('.phone-form').val(),
      city: maxmindObj ? maxmindObj.cityName : '',
      country: maxmindObj ? maxmindObj.countryName : '',
      firstName: $form.find('.first-name-form').val(),
      lastName: $form.find('.last-name-form').val(),
      cache_id: uid, // TODO
      website: Cookie.get('fw_flu') || '',
      referrer: Cookie.get('fw_fr') || ''
    };
  } catch (e) {

  }

  // Signup Spam detection
  var spamOptions = {
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    url: spamCheckUrl,
    data: JSON.stringify(spamData)
  };

  if (maxmindObj && maxmindObj.ipAddress && maxmindObj.ipAddress.length > 0 && emailOld !== emailNew) {
    emailOld = emailNew;
    uidOld = uid;
    $.when(
      $.ajax(signupOptions),
      $.ajax(spamOptions)
    )
      .done(function (signupResponse, spamResponse) {
        if (signupResponse[0].success && spamResponse[0].statusCode === 200) {
          signupResponse.composite_stitching_key = compositeKey;
          fdeskSignupFormSuccess($form, signupResponse, false, spamResponse);
        } else {
          const signUpError = signupResponse[0].success ? 'Freshdesk Spam API Error' : 'Freshdesk Signup API Error';
          const failureLogMessage = signUpError;
          const responseObject = {
            SignupResponse: signupResponse[0],
            SpamResponse: spamResponse[0]
          };
          if (signupResponse[0].success) {
            SiteUtilities.classifyStatusCode(`${signUpError}`, 'fdeskForm', responseObject.SignupResponse);
          }
          if (signupResponse[0].errors) {
          // log all signup errors except "Domain is not available" error.
            if (signUpError === 'Freshdesk Signup API Error' && signupResponse[0].errors[0][1] && signupResponse[0].errors[0][1] !== 'Domain is not available!') {
              SiteUtilities.log(`${signUpError}`, 'warning', 'fdeskForm', '0', responseObject.SpamResponse);
              failureLogData['message'] = `Signup API call succeeded - Received Error Response. Error: ${failureLogMessage} - ${responseObject.SignupResponse}`;
              SiteUtilities.signupErrorLog(failureLogData, form);
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = signupResponse[0].errors[0];
            $form.find('.backend-error-wrapper').html(domainError);
          }
          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        SiteUtilities.classifyStatusCode(jqXHR.status, `Freshdesk Signup API call failed. StatusCode: ${jqXHR.status}`, 'Freshdesk Signup', responseObject);
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        var err = JSON.parse(jqXHR.responseText);
        $form.find('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html('<em class="error">' + err.errors[0] + '</em>');
      });
  } else {
    $.ajax(signupOptions)
      .done(function (signupResponse) {
        if (signupResponse.success) {
          signupResponse.composite_stitching_key = compositeKey;
          fdeskSignupFormSuccess($form, signupResponse);
        } else {
          if (signupResponse.errors) {
            if (signupResponse.errors[0][1] && signupResponse.errors[0][1] !== 'Domain is not available!') {
              failureLogData['message'] = `Freshdesk Signup API call succeeded - received error response, Error: ${signupResponse.errors[0]}`;
              SiteUtilities.signupErrorLog(failureLogData, form);
              const responseObject = {
                SignupResponse: signupResponse
              };
              SiteUtilities.log('Freshdesk Signup API call succeeded - received error response', 'warning', 'fdeskForm', '0', responseObject);
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = signupResponse.errors[0];
            $form.find('.backend-error-wrapper').html(domainError);
          }
          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        failureLogData['message'] = `Freshdesk Signup API call failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText}`;
        SiteUtilities.signupErrorLog(failureLogData, form);
        SiteUtilities.classifyStatusCode(jqXHR.status, `Freshdesk Signup API call failed. StatusCode: ${jqXHR.status}`, 'fdeskForm', responseObject);
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        var err = JSON.parse(jqXHR.responseText);
        $form.find('.email-form').parent('.form-field').addClass('error').find('.error-wrapper').html('<em class="error">' + err.errors[0] + '</em>');
      });
  }
  return false;
};

const fdeskSignupFormSuccess = function ($form, response, alohaV2 = false, spamResponse = false) {
  const email = $form.find('.email-form').val();
  const emailHash = SiteUtilities.getShaHash(email);
  const geoLocation = LocationUtilities.getGeoLocation();
  const redirect = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect'));
  const redirectSpam = SiteUtilities.trimAndremoveTrailingSlash($form.attr('data-redirect-spam'));
  const isExternalIframeSignup = $form.parents('.external-iframe-signup').length;
  const currentReferrer = SiteUtilities.getCurrentReferrer();

  SiteUtilities.configureAssetId($form, 'fdesk');

  let redirectUrl = '#';
  let spamScore = 0;
  let accountId = '';
  if (alohaV2) {
    const signupResponse = response['product_signup_response'];
    redirectUrl = signupResponse['redirect_url'].replace(/\/$/, '');
    accountId = (signupResponse.account && signupResponse.account.id) ? signupResponse.account.id : null;
  } else {
    if (spamResponse) {
      const spamResponseBody = JSON.parse(spamResponse[0].body);
      spamScore = spamResponseBody.Results['RISK SCORE'];
      accountId = response[0].account_id;
      redirectUrl = response[0].url;
    } else {
      redirectUrl = response.url;
      accountId = response.account_id;
    }
  }

  // Storing growsumo data
  const gsdata = {
    first_name: $form.find('.first-name-form').val(),
    email_id: $form.find('.email-form').val(),
    domain: $form.find('.domain-form').val() || null,
    account_id: 'fdesk.' + accountId
  };
  localStorage.setItem('gsdata', JSON.stringify(gsdata));

  // Post to freshmarketer.
  // Construct freshmarketer object for api submission only on 200 status code
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: $form.find('.first-name-form').val(),
      last_name: $form.find('.last-name-form').val(),
      email: email,
      phone: $form.find('.phone-form').val() || '',
      company: $form.find('.company-form').val(),
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_fdesklastreferrer: Cookie.get('fw_flu') || '',
        cf_fdesksignupreferrer: window.location.href || '',
        cf_signupdevice: ResponsiveUtilities.getDeviceType(),
        cf_freshmarketer_list: $form.find('.fm-list-id').val(),
        cf_department: $form.find('.department-form').val() || '',
        cf_joblevel: $form.find('.job-level-form').val() || ''
      },
      domainUrl: redirectUrl,
      product: 'Freshdesk',
      accountId: accountId,
      composite_stitching_key: response.composite_stitching_key || null
    }
  };

  const isBusinessEmail = SiteUtilities.isBusinessEmail(email);
  if (!isBusinessEmail) {
    freshmarketerData.freshmarketerObject.custom_field['cf_leadspaceindustry'] = $form.find('.company-industry-form').val() || '';
    freshmarketerData.freshmarketerObject.custom_field['cf_website'] = $form.find('.website-form').val() || '';
  }

  GA4Utilities.ga4ThankYouEvent(accountId, redirectUrl, $form);
  SiteUtilities.passSignupResponseToGA(accountId, redirectUrl, 'Freshdesk');

  // Code to add a param to the thank-you page for referral program sign-ups
  const utmSource = SiteUtilities.getParameterByName('utm_source');
  let referralParam = '';
  if (utmSource && utmSource === 'invitereferrals') {
    referralParam = `&referral_sign_up=${encodeURIComponent('true')}&email=${encodeURIComponent($form.find('.email-form').val())}&username=${encodeURIComponent(($form.find('.first-name-form').val()) + ($form.find('.last-name-form').val()))}`;
  }

  const planName = SiteUtilities.getParameterByName('plan');
  if (planName && planName !== '') {
    redirectUrl = redirectUrl + '?plan=' + planName;
  }

  // Construct final redirect URL
  const redirectUrlEncode = encodeURIComponent(redirectUrl);
  let thankYouRedirect = (spamScore < 5) ? `${redirect}/?redirect=${redirectUrlEncode}${referralParam}&aid=${accountId}&ehash=${emailHash}` : `${redirectSpam}/?redirect=${redirectUrlEncode}${referralParam}&aid=${accountId}&ehash=${emailHash}`;
  if (isExternalIframeSignup) {
    thankYouRedirect += '&post_to_partner=true';
    if (currentReferrer) {
      thankYouRedirect += `&first_referrer=${encodeURIComponent(currentReferrer)}`;
    }
  }

  const loadGtmScriptsOnSignupCompletionAsync = (thankYouRedirect, email) => {
    SiteUtilities.historyPushState(thankYouRedirect, false);

    // Below GTM script should run only for English.
    const lang = jQuery('body').data('lang');
    if (lang !== 'en') return jQuery.Deferred().resolve();

    const trackSignupConversion = () => {
      // Part of Enhanced conversion tag
      window.dataLayer = window.dataLayer || [];
      function gtag () { window.dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'AW-996274243', { allow_enhanced_conversions: true });

      // Part of Enhanced conversion tag
      window.enhanced_conversion_data = { email };

      // Event snippet for Signup conversion page
      gtag('event', 'conversion', { send_to: 'AW-996274243/tTYgCK3EzAIQw-CH2wM' });
    };

    // Create an array of script URLs to load in parallel
    const scriptUrls = ['https://www.googletagmanager.com/gtag/js?id=AW-996274243'];

    return Promise.all(scriptUrls.map(SiteUtilities.loadScriptWithPromise))
      .then(() => {
        trackSignupConversion();
      })
      .catch(error => {
        SiteUtilities.log(
          'Error in loadGtmScriptsOnSignupCompletionAsync',
          'error',
          'fdesk-form-handlers.js',
          1,
          error
        );
      });
  };

  const leadCapture = () => {
    // Construct growsumo and fm collector payload.
    const growSumoPayload = SiteUtilities.buildGrowSumoPayload('pk_ZUb1nXFPs1riXIiwEozmL4trdtiWngWL', '');
    const collectorPayload = SiteUtilities.freshmarketerPost(freshmarketerData, false, $form, false);
    const awinConversionPayload = getAwinConversionPayload({ product: 'fdesk', email: gsdata.email_id, accountId });
    const admitadPayload = SiteUtilities.buildAdmitadPayload(growSumoPayload.customer_key);

    localStorage.setItem('fmarketerStartTime', new Date().toISOString());
    jQuery.when(
      SiteUtilities.postToKinesis({ growSumoPost: growSumoPayload, fmCollectorPost: collectorPayload, awinConversionPost: awinConversionPayload, admitadPost: admitadPayload }),
      loadGtmScriptsOnSignupCompletionAsync(thankYouRedirect, email)
    ).catch(function (e) {
      SiteUtilities.log(
        'Error in Freshmarketer or GrowSumo Post API Call',
        'error',
        'fdesk-form-handlers.js',
        1,
        e
      );
    }).always(function () {
      localStorage.setItem('fmarketerEndTime', new Date().toISOString());
      localStorage.removeItem('gsdata');
      SiteUtilities.triggersignupPerformanceLogApi(true);
      SiteUtilities.signupToProductRedirect(redirectUrl, isExternalIframeSignup);
    });
  };
  setTimeout(leadCapture, 0);
};

var fdeskLoginForm = function (classname, form) {
  const $form = $(form);
  const domain = $form.find('input.domain-form').val();
  $form.find('input.domain-form').parents('.form-field').removeClass('error');
  window.location.href = 'https://' + domain + '.freshdesk.com';
  GA4Utilities.loginFormSubmit(domain);
};

var fdeskForgotDomainForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const forgotDomainUrl = $form.data('forgot-domain-url') || 'https://signup.freshdesk.com/search_user_domain.json';
  const settings = {
    async: false,
    crossDomain: true,
    url: forgotDomainUrl,
    type: 'GET',
    data: {
      user_email: email
    }
  };
  jQuery.ajax(settings).done(function (data, textStatus, jqXHR) {
    if (data.available) {
      jQuery('.form-wrapper', '.forgot-domain-form-wrapper').slideUp(300);
      setTimeout(function () {
        jQuery('.forgot-domain-success').slideDown(300);
      }, 300);
    } else {
      const errorMessage = "<em class='error'>This email does not exist</em>";
      $form.find('.email-form').parents('.form-field').addClass('error').find('.error-wrapper').empty().append(errorMessage);
    }
  }).fail(function () {
    const errorMessage = "<em class='error'>Error contacting the api</em>";
    $form.find('.email-form').parents('.form-field').addClass('error').find('.error-wrapper').empty().append(errorMessage);
  });
};

const fdeskDemoRequestForm = (className, form) => {
  const $form = $(form);
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  const emailid = $form.find('input.email-form').val();
  const emailHash = SiteUtilities.getShaHash(emailid);
  const firstName = $form.find('input.first-name-form').val();
  const lastName = $form.find('input.last-name-form').val();
  const phone = $form.find('input.phone-form').val();
  const companyName = $form.find('input.company-form').val();
  const geoLocation = LocationUtilities.getGeoLocation();
  // const formSourceType = $form.attr('data-form-source');
  // let agentSize = $($form.find('input[name="agents-fdesk-demo-calendly-form"]')).val();
  // const locationData = sessionObj.simpleGeoLocation;
  // let progressList = $('.progress-list-item');
  // Classify the visitor based on their region
  // if (locationData && embargoed.indexOf(locationData.countryName < 0)) { // embargo check
  //   if (locationData.continent === 'AS') {
  //     if (locationData.countryName === 'Singapore' || locationData.countryName === 'Hong Kong') {
  //       urlSelector = 'anz';
  //     } else if (middleEast.indexOf(locationData.countryName) >= 0) {
  //       urlSelector = 'me';
  //     } else if (resellerAsiaBlock.indexOf(locationData.countryName) < 0) {
  //       urlSelector = 'ind';
  //     }
  //   } else if (locationData.continent === 'AF') {
  //     if (locationData.countryName === 'Egypt') {
  //       urlSelector = 'me';
  //     } else {
  //       urlSelector = 'afr';
  //     }
  //   } else if (locationData.continent === 'EU') {
  //     if (locationData.countryName === 'United Kingdom') {
  //       urlSelector = 'uk';
  //     } else {
  //       urlSelector = 'eu';
  //     }
  //   } else if (locationData.continent === 'OC') {
  //     urlSelector = 'anz';
  //   } else if (locationData.continent === 'NA') {
  //     if (usEast.indexOf(geoLocation.timeZone) >= 0) {
  //       urlSelector = 'use';
  //     } else {
  //       urlSelector = 'usw';
  //     }
  //   }
  // }

  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      first_name: firstName,
      last_name: lastName,
      email: emailid,
      company: companyName,
      country: geoLocation ? geoLocation.countryName : '',
      phone: phone,
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };

  // enable if there is no calendly.
  // after form submit it redirect to request thank you page.
  setTimeout(function () {
    jQuery.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, form)
    ).then(function () {
      window.location.href = $form.attr('data-redirect') + `/?ehash=${emailHash}`;
    });
  }, 500);

  // Load the calendly widget in the page
//   $form.addClass('active').siblings('h3').addClass('active');
//   setTimeout(function () {
//     $form.siblings('.thank-you-card').addClass('active');
//   }, 100);
//   $form.closest('.animate-form-wrapper').addClass('calendly-active');
//   let calendlyScriptTag = document.createElement('script');
//   calendlyScriptTag.src = 'https://calendly.com/assets/external/widget.js';
//   if (urlSelector !== '') {
//     dataUrl = `https://calendly.com/${demoEmbedUrls[urlSelector]}/demo?name=${encodeURIComponent(firstName)}&email=${encodeURIComponent(emailid)}`;
//     $('.calendly-inline-widget').attr('data-url', dataUrl);
//     $('.calendly-data-container').append(calendlyScriptTag);
//     $(progressList[0]).find('.progress-list-circle').empty();
//     $(progressList[0]).removeClass('active').addClass('complete').siblings().addClass('active');
//   }
};

var fdeskAcademyCoursesForm = function (classname, form) {
  const $form = $(form);
  const email = $form.find('.email-form').val();
  const group = $form.find('.select-form').val();
  const academyRegistrationUrl = $form.data('academy-registration-url') || 'https://agent-hermes.freshdesk.com/fd-academy/users';
  var userdata = JSON.stringify({
    data: {
      attributes: {
        people: [{
          email: email,
          groups: group
        }]
      }
    }
  });

  var settings = {
    async: true,
    crossDomain: true,
    url: academyRegistrationUrl,
    type: 'POST',
    processData: false,
    data: userdata
  };

  $.ajax(settings)
    .done(function (response) {
      GenericFormHandlers.animateFormWrapper(classname);
    })
    .fail((jqXHR, textStatus) => {
      SiteUtilities.log(
        'Freshdesk academy form',
        'warning',
        'submitHandlers.fdeskAcademyForm (ajax call failed)',
        0,
        textStatus
      );
      GenericFormHandlers.animateFormWrapper(classname);
    });
};

var fdeskFeaturesListForm = function (classname, form) {
  window.ZargetFormAPI = window.ZargetFormAPI || [];
  window.ZargetFormAPI.push('zg_form', 'CompleteFeatureListSuccess');
  GenericFormHandlers.animateFormWrapper(classname);
  $('div.align-center h5').hide();
};

var fdeskGartnerMagicQuadrantForm = function (classname, form) {
  const $form = $(form);
  const email = $('.' + classname + ' input[name^=email-]').val();
  const emailHash = SiteUtilities.getShaHash(email);
  window.ZargetFormAPI = window.ZargetFormAPI || [];
  window.ZargetFormAPI.push('zg_form', 'GartnerMagicQuadrant2017Success');
  GenericFormHandlers.animateFormWrapper(classname);
  setTimeout(function () {
    const redirectUrl = $form.find('input[type="submit"]').attr('data-url');
    window.location = redirectUrl + `?ehash=${emailHash}`;
  }, 3000);
};

var fdeskCaseStudyForm = function (className, form) {
  const $form = $(form);
  const emailid = $form.find('input[name^="email"]').val();
  const geoLocation = LocationUtilities.getGeoLocation();
  $('.' + className).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  // Freshmarketer Data
  const freshmarketerData = {
    freshmarketerObject: {
      email: emailid,
      country: geoLocation ? geoLocation.countryName : '',
      contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
      custom_field: {
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      }
    }
  };
  SiteUtilities.freshmarketerPost(freshmarketerData, true, form);
  setTimeout(function () {
    $('.email-only-form-wrapper.font-color-light .lazy-image-wrapper.image-wrapper-40').css('visibility', 'hidden');
    $('.email-only-form-wrapper form, .email-only-form-wrapper .thank-you-card').addClass('active');
  }, 500);
};

const fdeskEmailOnlySignupForm = function (classname, form) {
  const $form = $(form);
  const domainName = $form.find('.email-fdesk').val();
  const emailHash = SiteUtilities.getShaHash(domainName);
  const emailSignUpUrl = 'https://freshsignup.freshdesk.com/accounts/email_signup';
  const spamCheckUrl = $form.data('spam-check-url') || 'https://alfred.freshworks.com/v1/dark-knight';
  // Presetted and Fetched constants
  const apiDomain = emailSignUpUrl;
  let postData = {};
  let spamData = {};
  let redirectUrl = '#';
  let currentLoc = '';
  let perishableToken;
  let productDomain;
  const $signUpBtn = $form.find('.button');
  $form.find('.button').addClass('button--loading').attr('disabled', 'disabled');
  let uid = SiteUtilities.generateUID();
  const redirect = $form.attr('data-redirect');
  const redirectSpam = $form.attr('data-redirect-alternative');
  const buttonValue = $form.find('.button').val();
  const firstReferrer = Cookie.get('fw_fr') || currentLoc;
  const lastReferrer = Cookie.get('fw_flu') || '';
  // Setting Values
  $form.find('input[name="first_referrer-' + classname + '"]').val(firstReferrer);
  $form.find('input[name="first_landing_url-' + classname + '"]').val(lastReferrer);

  const fmAssetId = $form.find('.fm-asset-id').val() || $form.data('fm_asset_id') || 3649313;
  const tacticId = SiteUtilities.getTacticID() || '';
  const compositeKey = SiteUtilities.getCompositeKey(domainName, fmAssetId, tacticId);

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  if (sessionObj) {
    sessionObj.composite_stitching_key = compositeKey;
    sessionObj.allocadia_asset_id = fmAssetId;
    sessionObj.allocadia_tactic_id = tacticId;

    sessionObj.ga_client_id = `${SiteUtilities.getGAClientID()}:${compositeKey}`;
  }

  // Binding maxmind_session
  sessionObj.location = LocationUtilities.getGeoLocation();
  const maxmindObj = sessionObj.location;
  const sessionJSON = JSON.stringify(sessionObj);
  currentLoc = (sessionObj && sessionObj.original_session) ? sessionObj.original_session.referrer : SiteUtilities.getCurrentLocation();

  // Bind username and fs_cookie
  let fsCookie = '';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshdesk session exception.',
      'error',
      'submitHandlers.fdeskEmailOnlySignupForm',
      2,
      exception
    );
  }

  const emailNew = $form.find('.email-fdesk').val();
  if (emailOld === emailNew) {
    uid = uidOld;
  }

  // Build postData
  postData = {
    user: { email: $form.find('.email-fdesk').val() },
    session_json: sessionJSON,
    first_referrer: currentLoc,
    first_landing_url: $form.find('input[name="first_landing_url-' + classname + '"]').val(),
    first_search_engine: sessionObj.original_session.search.engine,
    first_search_query: sessionObj.original_session.search.query,
    pre_visits: sessionObj.original_session.visits,
    fd_cid: uid,
    fs_cookie: fsCookie,
    signup_button: buttonValue
  };

  const ipAddress = (maxmindObj && maxmindObj.ipAddress) ? maxmindObj.ipAddress : null;

  const failureLogData = {
    source: 'FW.Submit.fdeskEmailOnlySignupForm',
    product: 'fdesk',
    ip_address: ipAddress,
    email: emailNew
  };

  // Posting signup to Freshdesk.
  const signupOptions = {
    async: true,
    crossDomain: true,
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
    url: apiDomain,
    processData: false,
    data: JSON.stringify(postData),
    error: logSignupErrOnFail(failureLogData, form)
  };

  try {
    spamData = {
      emailAddress: domainName,
      ipAddress: maxmindObj ? maxmindObj.ipAddress : '',
      city: maxmindObj ? maxmindObj.cityName : '',
      country: maxmindObj ? maxmindObj.countryName : '',
      cache_id: uid, // TODO
      referrer: $form.find('input[name="first_referrer-' + classname + '"]').val()
    };
  } catch (e) {

  }

  // Signup Spam detection
  var spamOptions = {
    type: 'POST',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    url: spamCheckUrl,
    data: JSON.stringify(spamData)
  };

  /**
   * Freshmarketer data
   */

  const freshmarketerData = {
    freshmarketerObject: {
      email: domainName,
      country: maxmindObj ? maxmindObj.countryName || '' : '',
      custom_field: {
        contactable: ($form.find('input[name="send_promotions"]').is(':checked')),
        cf_fdesklastreferrer: lastReferrer,
        cf_fdesksignupreferrer: window.location.href || '',
        cf_signupdevice: ResponsiveUtilities.getDeviceType(),
        cf_freshmarketer_list: $form.find('.fm-list-id').val()
      },
      composite_stitching_key: compositeKey || null
    }
  };

  /**
   * Note: Thank-you page redirection happens after lead capture
  */
  const leadCapture = locationHref => {
    $.when(
      SiteUtilities.freshmarketerPost(freshmarketerData, false, $form)
    ).then(function () {
      window.location.href = locationHref;
    });
  };

  if (maxmindObj && maxmindObj.ipAddress && maxmindObj.ipAddress.length > 0 && emailOld !== emailNew) {
    emailOld = emailNew;
    uidOld = uid;
    $.when(
      $.ajax(signupOptions),
      $.ajax(spamOptions)
    )
      .done(function (signupResponse, spamResponse) {
        if (signupResponse[0].success && spamResponse[0].statusCode === 200) {
          const spamResponseBody = JSON.parse(spamResponse[0].body);
          const spamScore = spamResponseBody.Results['RISK SCORE'];
          const signupResponseData = signupResponse[0].product_signup_response;
          redirectUrl = signupResponse[0].url;
          perishableToken = (signupResponseData.account && signupResponseData.account.token) ? signupResponseData.account.token : null;
          productDomain = (signupResponseData.domain && signupResponseData.account.domain) ? signupResponseData.account.domain : null;
          localStorage.setItem('perishable_token', perishableToken);
          localStorage.setItem('product_domain', productDomain);
          const redirectTo = spamScore < 5 ? 'thank-you' : 'success';
          const dimension = 'FdeskAcId-' + signupResponse[0].account_id;

          // Send data to google analytics
          try {
            const trackers = ga.getAll();
            const trackerLength = trackers.length;
            for (var t = 0; t < trackerLength; t++) {
              if (trackers[t].get('trackingId') === 'UA-20651269-1') {
                var trackerName = trackers[t].get('name');
                ga(trackerName + '.set', {
                  page: `/signup/${redirectTo}?redirect=${redirectUrl}&aid=${signupResponse[0].account_id}&ehash=${emailHash}`,
                  title: 'Signup Complete',
                  dimension1: dimension,
                  dimension5: spamScore,
                  dimension8: SiteUtilities.sanitizeGACookie(SiteUtilities.getGAClientID())
                });
                ga(trackerName + '.send', 'pageview', {
                  page: `/signup/${redirectTo}?redirect=${redirectUrl}&aid=${signupResponse[0].account_id}&ehash=${emailHash}`,
                  title: 'Signup Complete'
                });
                break;
              }
            }
          } catch (e) {
            SiteUtilities.log(e.message, 'error', 'fdesk-form-handler.fdeskEmailOnlyForm.try-catch', 2, e);
          }

          // Code to add a param to the thank-you page for referral program sign-ups
          const utmSource = SiteUtilities.getParameterByName('utm_source');
          let referralParam = '';
          if (utmSource && utmSource === 'invitereferrals') {
            referralParam = '&referral_sign_up=' + encodeURIComponent('true') + '&email=' + encodeURIComponent($form.find('.email-fdesk').val());
          }

          const planName = SiteUtilities.getParameterByName('plan');
          // Storing the redirect url locally to avoid XSS from url.
          (planName && planName !== '') ? localStorage.setItem('redirect_url', redirectUrl + '?plan=' + planName) : localStorage.setItem('redirect_url', redirectUrl);
          // Storing spam score to pass to GTM
          localStorage.setItem('risk_score', spamScore);
          // Storing growsumo data
          var gsdata = {
            email_id: $form.find('.email-fdesk').val()
          };
          localStorage.setItem('gsdata', JSON.stringify(gsdata));
          const locationHref = (spamScore < 5) ? `${redirect}/?redirect=` + encodeURIComponent(redirectUrl) + referralParam + `&aid=${signupResponse[0].account_id}&ehash=${emailHash}` : `${redirectSpam}/?redirect=` + encodeURIComponent(redirectUrl) + referralParam + `&aid=${signupResponse[0].account_id}&ehash=${emailHash}`;
          // Adding account id and re-direct url to fmarkter post
          freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
          freshmarketerData.freshmarketerObject.product = 'Freshdesk';
          freshmarketerData.freshmarketerObject.accountId = signupResponse[0].account_id;
          leadCapture(locationHref);
          SiteUtilities.passSignupResponseToGA(signupResponse[0].account_id, redirectUrl || '', 'Freshdesk');
        } else {
          const signUpError = signupResponse[0].success ? 'Freshdesk Spam API Error' : 'Freshdesk Signup API Error';
          const failureLogMessage = signUpError;
          const responseObject = {
            SignupResponse: signupResponse[0],
            SpamResponse: spamResponse[0]
          };
          if (signupResponse[0].errors) {
          // log all signup errors except "Domain is not available" error.
            if (signUpError === 'Freshdesk Signup API Error' && signupResponse[0].errors[0] && signupResponse[0].errors[0] !== 'Domain is not available!') {
              SiteUtilities.log(
                signUpError,
                'error',
                'submitHandlers.fdeskEmailOnlySignupForm',
                2,
                responseObject
              );
              failureLogData['message'] = `Freshdesk Email only Signup API call succeeded - Received Error Response. Error: ${failureLogMessage} - ${responseObject.SignupResponse}`;
              SiteUtilities.signupErrorLog(failureLogData, form);
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = signupResponse[0].errors;
            $form.find('.backend-error-wrapper').html(domainError[0]);
          }

          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
          $form.find('.email-field').addClass('error').find('.error-wrapper').html('<em class="error">' + signupResponse[0].errors[0] + '</em>');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        SiteUtilities.log(
          `Freshdesk Signup API call failed. StatusCode: ${jqXHR.status}`,
          'error',
          'submitHandlers.fdeskEmailOnlySignupForm',
          2,
          responseObject
        );
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        var err = JSON.parse(jqXHR.responseText);
        var errorMsg = '';
        $.each(err.errors, function (i, value) {
          errorMsg += value + '<br/>';
          $form.find('.email-field').addClass('error').find('.error-wrapper').html('<em class="error">' + errorMsg + '</em>');
        });
      });
  } else {
    $.ajax(signupOptions)
      .done(function (signupResponse) {
        if (signupResponse.success) {
          redirectUrl = signupResponse.url;
          const spamScore = localStorage.getItem('risk_score') || 0;
          const redirectTo = spamScore < 5 ? 'thank-you' : 'success';
          const dimension = 'FdeskAcId-' + signupResponse.account_id;

          // Send data to google analytics
          try {
            const trackers = ga.getAll();
            const trackerLength = trackers.length;
            for (var t = 0; t < trackerLength; t++) {
              if (trackers[t].get('trackingId') === 'UA-20651269-1') {
                var trackerName = trackers[t].get('name');
                ga(trackerName + '.set', {
                  page: `/signup/${redirectTo}?redirect=${redirectUrl}&aid=${signupResponse.account_id}&ehash=${emailHash}`,
                  title: 'Signup Complete',
                  dimension1: dimension,
                  dimension5: 'None',
                  dimension8: SiteUtilities.sanitizeGACookie(SiteUtilities.getGAClientID())
                });
                ga(trackerName + '.send', 'pageview', {
                  page: `/signup/${redirectTo}?redirect=${redirectUrl}&aid=${signupResponse.account_id}&ehash=${emailHash}`,
                  title: 'Signup Complete'
                });
                break;
              }
            }
          } catch (e) {
            SiteUtilities.log(e.message, 'error', 'fdesk-form-handler.fdeskEmailOnlyForm.try-catch', 2, e);
          }

          // Code to add a param to the thank-you page for referral program sign-ups
          const utmSource = SiteUtilities.getParameterByName('utm_source');
          let referralParam = '';
          if (utmSource && utmSource === 'invitereferrals') {
            referralParam = '&referral_sign_up=' + encodeURIComponent('true') + '&email=' + encodeURIComponent($form.find('.email-fdesk').val());
          }

          const planName = SiteUtilities.getParameterByName('plan');
          // Storing the redirect url locally to avoid XSS from url.
          (planName && planName !== '') ? localStorage.setItem('redirect_url', redirectUrl + '?plan=' + planName) : localStorage.setItem('redirect_url', redirectUrl);
          const locationHref = '/trial/thank-you/?redirect=' + encodeURIComponent(redirectUrl) + referralParam + `&aid=${signupResponse.account_id}&ehash=${emailHash}`;

          // Adding account id and re-direct url to fmarkter post
          freshmarketerData.freshmarketerObject.domainUrl = redirectUrl;
          freshmarketerData.freshmarketerObject.product = 'Freshdesk';
          freshmarketerData.freshmarketerObject.accountId = signupResponse.account_id;
          SiteUtilities.passSignupResponseToGA(signupResponse.account_id, redirectUrl || '', 'Freshdesk');
          leadCapture(locationHref);
        } else {
          if (signupResponse.errors) {
            if (signupResponse.errors[0] && signupResponse.errors[0] !== 'Domain is not available!') {
              failureLogData['message'] = `Freshdesk Email only Signup API call succeeded - received error response, Error: ${signupResponse.errors[0]}`;
              SiteUtilities.signupErrorLog(failureLogData, form);
              const responseObject = {
                SignupResponse: signupResponse
              };
              SiteUtilities.log(
                'Freshdesk Signup API call succeeded - received error response.',
                'error',
                'submitHandlers.fdeskEmailOnlySignupForm',
                2,
                responseObject
              );
            }
            $form.find('.backend-error-wrapper').fadeIn('fast', 'swing').parent('.form-field').addClass('error');
            const domainError = signupResponse.errors;
            $form.find('.backend-error-wrapper').html(domainError[0]);
          }

          $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
          $form.find('.email-field').addClass('error').find('.error-wrapper').html('<em class="error">' + signupResponse.errors[0] + '</em>');
        }
      })
      .fail((jqXHR, textStatus, errorThrown) => {
        const responseObject = {
          jqXHR,
          textStatus,
          errorThrown
        };
        failureLogData['message'] = `Freshdesk Email only Signup API call failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText}`;
        SiteUtilities.signupErrorLog(failureLogData, form);
        SiteUtilities.log(
          'Freshdesk Signup API call failed.',
          'error',
          'submitHandlers.fdeskEmailOnlySignupForm',
          2,
          responseObject
        );
        $signUpBtn.removeClass('button--loading').val('Retry').removeAttr('disabled');
        var err = JSON.parse(jqXHR.responseText);
        var errorMsg = '';
        $.each(err.errors, function (i, value) {
          errorMsg += value + '<br/>';
          $form.find('.email-field').addClass('error').find('.error-wrapper').html('<em class="error">' + errorMsg + '</em>');
        });
      });
  }
  return false;
};

var fdeskSignupForm = function (className, form) {
  $('.' + className).find('.button').addClass('button--loading').attr('disabled', 'disabled');
  setTimeout(function () {
    $('.email-only-form-wrapper h2, .email-only-form-wrapper form, .email-only-form-wrapper p, .email-only-form-wrapper .thank-you-card').addClass('active');
  }, 500);
};

const fdeskTryWithoutSignupForm = function (classname, form) {
  const $form = $(form);
  // Presetted and Fetched constants
  const apiDomain = 'https://freshsignup.freshdesk.com/accounts/anonymous_signup';
  let postData = {};
  let redirectUrl = '#';
  const $signUpBtn = $form.find('.button');
  $signUpBtn.addClass('button--loading').attr('disabled', 'disabled');
  const uid = SiteUtilities.generateUID();
  const buttonValue = $signUpBtn.val();
  const buttonValueFailed = $('#button-label-failed').val();
  const loadingButtonValue = $signUpBtn.data('loading-text');
  if (loadingButtonValue) {
    $signUpBtn.val(loadingButtonValue);
  }

  const sessionObj = window.session ? JSON.parse(JSON.stringify(window.session)) : {};
  sessionObj.location = LocationUtilities.getGeoLocation();
  const sessionJSON = JSON.stringify(sessionObj);
  const currentLoc = (sessionObj && sessionObj.original_session) ? sessionObj.original_session.referrer : SiteUtilities.getCurrentLocation();

  // Bind username and fs_cookie
  let fsCookie = '';
  try {
    fsCookie = freshsales.anonymous_id;
  } catch (exception) {
    SiteUtilities.log(
      'Freshdesk session exception.',
      'error',
      'submitHandlers.fdeskTryWithoutSignupForm',
      2,
      exception
    );
  }

  // Build postData
  postData = {
    session_json: sessionJSON,
    first_referrer: currentLoc,
    first_search_engine: sessionObj.original_session.search.engine,
    first_search_query: sessionObj.original_session.search.query,
    pre_visits: sessionObj.original_session.visits,
    fd_cid: uid,
    fs_cookie: fsCookie,
    signup_button: buttonValue
  };

  // Posting signup to Freshdesk.
  const signupOptions = {
    type: 'POST',
    dataType: 'json',
    url: apiDomain,
    data: postData,
    crossDomain: true
  };

  const location = LocationUtilities.getGeoLocation();
  const ipAddress = (location && location.ipAddress) ? location.ipAddress : null;

  const failureLogData = {
    source: 'FW.Submit.fdeskTryWithoutSignupForm',
    product: 'fdesk',
    ip_address: ipAddress
  };

  $.ajax(signupOptions)
    .done(function (signupResponse) {
      if (signupResponse.success) {
        redirectUrl = signupResponse.url;

        // Send data to google analytics
        try {
          const trackers = ga.getAll();
          const trackerLength = trackers.length;
          for (let t = 0; t < trackerLength; t++) {
            const trackerName = trackers[t].get('name');
            ga(trackerName + '.set', {
              page: `/trial/completed?redirect=${redirectUrl}&aid=${signupResponse.account_id}&demo_account=true&account_type=sandbox_product_test`,
              title: 'Signup Complete'
            });
            ga(trackerName + '.send', 'pageview', {
              page: `/trial/completed?redirect=${redirectUrl}&aid=${signupResponse.account_id}&demo_account=true&account_type=sandbox_product_test`,
              title: 'Signup Complete'
            });
          }
        } catch (e) {
          SiteUtilities.log(e.message, 'error', 'fdesk-form-handler.fdeskTryWithoutSignupForm.try-catch', 2, e);
        }

        window.location.href = redirectUrl;
      } else {
        const responseObject = {
          SignupResponse: signupResponse
        };
        SiteUtilities.log(
          'Freshdesk Signup API call succeeded - received error response.',
          'error',
          'submitHandlers.fdeskTryWithoutSignupForm',
          2,
          responseObject
        );
        $signUpBtn.removeClass('button--loading').val(buttonValueFailed).removeAttr('disabled');
        $form.addClass('error').find('.error-wrapper').html('<em class="error">' + signupResponse.errors[0] + '</em>');
        failureLogData['message'] = `Freshdesk Try Without Signup API call succeeded - received error response, Error: ${signupResponse.errors[0]}`;
        SiteUtilities.signupErrorLog(failureLogData, form);
      }
      $signUpBtn.val(buttonValue);
    })
    .fail((jqXHR, textStatus, errorThrown) => {
      const responseObject = {
        jqXHR,
        textStatus,
        errorThrown
      };
      failureLogData['message'] = `Freshdesk Try Without Signup API call failed. StatusCode: ${jqXHR.status}, Error: ${jqXHR.responseText}`;
      SiteUtilities.signupErrorLog(failureLogData, form);
      SiteUtilities.log(
        'Freshdesk Signup API call failed.',
        'error',
        'submitHandlers.fdeskTryWithoutSignupForm',
        2,
        responseObject
      );
      $signUpBtn.removeClass('button--loading').val(buttonValueFailed).removeAttr('disabled');
      const errorMsg = jqXHR.statusText;
      $form.addClass('error').find('.error-wrapper').html('<em class="error">' + errorMsg + '</em>');
      $signUpBtn.val(buttonValue);
    });

  return false;
};

export default {
  fdeskForm,
  fdeskSignupForm,
  fdeskLoginForm,
  fdeskForgotDomainForm,
  fdeskDemoRequestForm,
  fdeskAcademyCoursesForm,
  fdeskFeaturesListForm,
  fdeskGartnerMagicQuadrantForm,
  fdeskCaseStudyForm,
  fdeskEmailOnlySignupForm,
  fdeskTryWithoutSignupForm,
  fdeskSignupFormSuccess
};
